import { ClockIcon, EuroIcon, LocationIcon } from '@/components/icons'
import { H3 } from '@/components/typography'
import { VacancyDetail } from '@/interfaces/vacancy'
import Block from '@/layouts/block'
import { ReactNode } from 'react'

const GeneralInfoPoint = ({
  iconComponent,
  text,
}: {
  iconComponent: ReactNode
  text: string
}) => {
  return (
    <div className="flex items-center">
      {iconComponent}
      <H3 className="ml-2">{text}</H3>
    </div>
  )
}

const GeneralInfoContent = ({
  location,
  salaryValue,
  hoursPerWeek,
}: Pick<VacancyDetail, 'location' | 'salaryValue' | 'hoursPerWeek'>) => {
  return (
    <Block className="vacancyGeneralInfoContent w-full flex flex-wrap px-6 py-6 items-center gap-8 col-span-full">
      {location && (
        <GeneralInfoPoint
          iconComponent={<LocationIcon height="25" width="25" />}
          text={location}
        />
      )}
      {salaryValue && (
        <GeneralInfoPoint
          iconComponent={<EuroIcon height="25" width="25" />}
          text={salaryValue}
        />
      )}
      {hoursPerWeek && (
        <GeneralInfoPoint
          iconComponent={<ClockIcon height="25" width="25" />}
          text={`${hoursPerWeek} per week`}
        />
      )}
    </Block>
  )
}

export default GeneralInfoContent
